var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPageBuilder(_vm.routeData.description))?_c('div',{attrs:{"id":"home"}},[_c('PageBuilder',{attrs:{"content":_vm.routeData.description,"updated":_vm.routeData.updated_at,"id":("category-" + (_vm.routeData.uid))}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }